// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TuTwN","selected":"styles_selected__12zvH"};